// extracted by mini-css-extract-plugin
export default {"galryimage":"OurProject_galryimage__s0euI","btnmore":"OurProject_btnmore__U-Gc9","more":"OurProject_more__Thyqt","gallerymt":"OurProject_gallerymt__GUbBf"};